import React from 'react'
import { SourceName } from '..'
import { css } from '@emotion/css'
import { updateRoute } from '../../route'
import { FormattedMessage } from 'react-intl'
import { legacyTheme } from '../../../legacy-design-system/legacy-theme'
import { ellipsis } from 'polished'
import { Link } from '@contrast-security-inc/design-system-typography'

const routeToEditSourceName = (organizationID: string, sourceNameId: string) =>
  updateRoute(`/${organizationID}/rules/ip/source-names/edit/${sourceNameId}`)

export function SourceNameCell({
  organizationID,
  rowData: { id: sourceNameID, name, expired }
}: {
  readonly organizationID: string
  readonly rowData: SourceName
}) {
  return (
    <div
      className={css`
        color: #000;
        display: flex;
        flex: 1;
      `}
    >
      <div
        className={css`
          flex: 4;
          ${ellipsis()}
        `}
      >
        <Link
          className={css`
            color: black;
            &:hover {
              text-decoration: underline;
              color: black;
            }
            &:link,
            &:visited,
            &:hover,
            &:focus {
              color: black;
            }
          `}
          onClick={() => routeToEditSourceName(organizationID, sourceNameID)}
        >
          {name}
        </Link>
      </div>
      {expired === true && (
        <div
          className={css`
            flex: 1;
            display: flex;
            padding-right: 20px;
            justify-content: flex-end;
            font-size: 12px;
            color: ${legacyTheme.colors.grayMiddle};
          `}
        >
          <FormattedMessage id="title_ipsManagement_ipSourceNames_sourceNamesExpired" />
        </div>
      )}
    </div>
  )
}
